import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=d964f15e&scoped=true"
import script from "./Pesquisa.vue?vue&type=script&lang=js"
export * from "./Pesquisa.vue?vue&type=script&lang=js"
import style0 from "./Pesquisa.vue?vue&type=style&index=0&id=d964f15e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d964f15e",
  null
  
)

export default component.exports